/* @flow */
const QueryParams = {
  platform() {
    return this._queryParams().platform;
  },

  resetPasswordCode() {
    return this._queryParams().reset_password_code;
  },

  transferAccountCode() {
    return this._queryParams().transfer_account_code;
  },

  _queryParams() {
    if (this._cachedParams) {
      return this._cachedParams;
    }

    this._cachedParams = window.location.search
      .replace(/(^\?)/, "")
      .split("&")
      .reduce((obj, pairStr) => {
        const [key, value] = pairStr.split("=");
        obj[key] = value;
        return obj;
      }, {});

    return this._cachedParams;
  },
};

export default QueryParams;



// WEBPACK FOOTER //
// ../nx-components/src/QueryParams.js